import React, { FunctionComponent } from 'react';
import StylesType from '@/types/StylesType';
import { Icon, Button } from '@/components';
import { Row, Col } from 'antd';

export interface SyncRoomHeadProps extends StylesType {
    onChange: () => void;
    title?: string;
    content?: string;
}


export const SyncRoomHead: FunctionComponent<SyncRoomHeadProps> = props => {

    const { title, content, prefixCls,onChange } = props;

    return (
        <Row className={prefixCls} type='flex' justify='space-between' align='middle'>
            <Col>
                <h1 className={`${prefixCls}-title`}>{title}</h1>
            </Col>
            <Col className={`${prefixCls}-center`}>
                <Icon className={`${prefixCls}-center-iconC`} type='iconinformation' />
                <span className={`${prefixCls}-center-content`}>{content}</span>
            </Col>
            <Col>
                <Col>
                    <Button onClick={onChange} type="primary" className={`${prefixCls}-button`}><Icon type='icontuichutongbu' />退出同步</Button>
                </Col>
            </Col>
        </Row>
    )
}

SyncRoomHead.defaultProps = {
    prefixCls: 'gc-async-head',
    title: '云机同步中',
    content: '注：同步云机数不要超过100台，否则会发生严重卡顿情况。同步过程中部分云机画面延时属于正常现象'
}

export default SyncRoomHead;
